import { AppAd } from "./ad";

export class AdInFeedTextOnly extends AppAd {
    constructor() {
        super({
            logLabel: 'AdInFeedTextOnly',
            hardCodedSlotId: true,
        });
    }

    buildHtml() {
        return `
            <ins class="adsbygoogle"
                style="display: block; min-width: 250px;"
                data-ad-format="fluid"
                data-ad-layout-key="-gw-3+1f-3d+2z"
                data-ad-client="ca-pub-1557542376119618"
                data-ad-slot="3383169900"
                ${this.lazyLoad ? 'data-loading="lazy"' : ''}>
            </ins>
        `;
    }
}
